import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/tools/tools';
import Documento from './Documento';


const ms2p = (state) => {
  return {
    ...state.tools,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Documento);
